import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import GoogleLogo from 'img/google-logo@2x.png';
import MicrosoftLogo from 'img/microsoft-logo@2x.png';

const GoogleAuthButton = observer(({authenticityToken, context, token}) => {
  return (
    <form action="/oauth?provider=google" method="post">
      <button className='Btn Btn--lg Btn--default full-width '>
        <span className='Btn--content'>
          <img src={GoogleLogo} alt='logo' height='18' className='inline-block' style={{margin: '0 24px 0 0'}}/>
          <div className='col col-6'>
            {t('login.GOOGLE_SIGN_IN')}
          </div>
        </span>
        <input type='hidden' name='authenticity_token' value={authenticityToken}/>
        <input type='hidden' name='context' value={context} />
        {token && <input type='hidden' name='type' value='user' />}
        {token && <input type='hidden' name='token' value={token} /> }
      </button>
    </form>
  );
});

const MicrosoftAuthButton = observer(({authenticityToken, context, token}) => {
  return (
    <form action="/oauth?provider=microsoft" method="post">
      <button className='Btn Btn--lg Btn--default full-width mt2'>
        <span className='Btn--content'>
          <img src={MicrosoftLogo} alt='logo' height='18' className='inline-block' style={{margin: '0 24px 0 0'}}/>
          <div className='col col-6'>
            {t('login.MICROSOFT_SIGN_IN')}
          </div>
        </span>
        <input type='hidden' name='authenticity_token' value={authenticityToken}/>
        <input type='hidden' name='context' value={context} />
        {token && <input type='hidden' name='type' value='user' />}
        {token && <input type='hidden' name='token' value={token} /> }
      </button>
    </form>
  );
});

const OAuth = observer(({authenticityToken, context, token}) => {
  return (
    <div className='center pb3 border-bottom mb3 relative'>
      <div className='clearfix'>
        <div className='flex flex-col md-flex-row center'>
          <div className='col col-12'>
            <GoogleAuthButton
              authenticityToken={authenticityToken}
              context={context}
              token={token}
            />
            <MicrosoftAuthButton
              authenticityToken={authenticityToken}
              context={context}
              token={token}
            />
          </div>
        </div>
      </div>
      <div className='absolute waterloo' style={{bottom: '-10px', background: '#fff', padding: '0 1rem', textTransform: 'uppercase', left: 'calc(50% - 2rem)' }} >
        <FormattedMessage id='login.or'/>
      </div>
    </div>
  );
});

OAuth.defaultProps = {
  context: 'login'
};

export default OAuth;
